import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'react-bootstrap';

import { toggleField } from '../actions';

import style from '../style.module.scss';

const ImportFields = () => {
  const importMappingFiles = useSelector((state) => state.templateExport.importMappingFiles);
  const dispatch = useDispatch();
  const toggleFieldAction = (field) => {
    dispatch(toggleField(field));
  };
  return (
    <div className={style.exportContainer}>
      <Card>
        <Card.Header className="py-3">
          <h4 className="mb-0">Import Settings</h4>
        </Card.Header>
        <Card.Body className="p-0">
          <div className={style.section}>
            <div className={style.exportItem}>
              <h5 className="mb-0">Mapping Files</h5>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="switcher m-1">
                <input
                  type="checkbox"
                  checked={importMappingFiles}
                  className="switcher-input"
                  onChange={() => toggleFieldAction('importMappingFiles')}
                />

                <span className="switcher-indicator">
                  <span className="switcher-yes" />
                  <span className="switcher-no" />
                </span>
              </label>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ImportFields;
